module.exports = __webpack_public_path__ + "static/media/cmu.41853406.png";